import Types from './types';

export const FieldActions = {
	Add:"Add",
	Delete:"Delete",
	Update:"Update",
	Rename:"Rename",
	Copy:"Copy",
}

export const FieldActionsForParentType = {
	[Types.array]:[
		FieldActions.Copy,
		FieldActions.Delete
	],
	[Types.object]:[
		FieldActions.Copy,
		FieldActions.Rename,
		FieldActions.Delete
	],
	default:[
		FieldActions.Copy,
		FieldActions.Delete
	]
}

export function getFieldActions(parentType, actionsCustomFilter) {
	const fieldActions =  FieldActionsForParentType[parentType] || FieldActionsForParentType.default;

	return actionsCustomFilter
		? fieldActions.reduce((acc, actionKey) => {
			const key = actionKey.split(' ').join('').toLowerCase();
			actionsCustomFilter[key] !== false && acc.push(actionKey);
			return acc;
		}, [])
		: fieldActions;
}

export default FieldActions;
